// store/slices/common/confirmModalSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// confirmModalSlice.ts

interface ConfirmModalState {
  isOpen: boolean;
  title: string;
  message: string;
  icon?: 'warning' | 'success' | 'error' | 'info';
  confirmText?: string;
  cancelText?: string;
  confirmArgs?: any; // <--- nuevo campo opcional
}

const initialState: ConfirmModalState = {
  isOpen: false,
  title: '',
  message: '',
  icon: 'warning',
  confirmText: 'Confirmar',
  cancelText: 'Cancelar',
};

const confirmModalSlice = createSlice({
  name: 'confirmModal',
  initialState,
  reducers: {
    showConfirmModal: (
      state,
      action: PayloadAction<{
        title: string;
        message: string;
        icon?: 'warning' | 'success' | 'error' | 'info';
        confirmText?: string;
        cancelText?: string;
        confirmArgs?: any;
      }>
    ) => {
      state.isOpen = true;
      state.title = action.payload.title;
      state.message = action.payload.message;
      state.icon = action.payload.icon || 'warning';
      state.confirmText = action.payload.confirmText || 'Confirmar';
      state.cancelText = action.payload.cancelText || 'Cancelar';
      state.confirmArgs = action.payload.confirmArgs;
    },
    hideConfirmModal: (state) => {
      Object.assign(state, initialState);
    },
  },
});


export const { showConfirmModal, hideConfirmModal } = confirmModalSlice.actions;
export default confirmModalSlice.reducer;
